import React from 'react';
import {normalizeOrderStatusCode} from '../../util/Constants';

export const ORDER_FLOW_STEPS = [
    {code: 'CREATED', label: 'Создан'},
    {code: 'PAID', label: 'Оплачен'},
    {code: 'SHIPPED', label: 'Отправлен'},
    {code: 'DELIVERED', label: 'Доставлен'},
];

export function orderFlowIndex(status) {
    const s = normalizeOrderStatusCode(status);
    if (s === 'CANCELED' || s === '') return -1;
    const i = ORDER_FLOW_STEPS.findIndex((x) => x.code === s);
    return i >= 0 ? i : 0;
}

function StepsRow({curIdx, ghost}) {
    const ghostClass = ghost ? 'invisible pointer-events-none select-none' : '';

    return (
        <div className={`flex flex-wrap items-center gap-y-2 ${ghostClass}`} aria-hidden={ghost || undefined}>
            {ORDER_FLOW_STEPS.map((step, i) => {
                const past = curIdx > i;
                const current = curIdx === i;
                return (
                    <React.Fragment key={step.code}>
                        {i > 0 && (
                            <div
                                className={`mx-1 hidden h-0.5 w-5 shrink-0 sm:block ${
                                    past || current ? 'bg-mustard-400' : 'bg-pine-600'
                                }`}
                                aria-hidden
                            />
                        )}
                        <div
                            className={`flex min-w-0 items-center gap-2 rounded-full border px-2.5 py-1.5 text-xs sm:px-3 sm:text-sm ${
                                current
                                    ? 'border-mustard-400 bg-mustard-500/30 text-cream-50 ring-2 ring-mustard-400/60'
                                    : past
                                      ? 'border-pine-500 bg-pine-800 text-cream-100'
                                      : 'border-pine-700 bg-pine-950/80 text-cream-300/90'
                            }`}
                        >
                            <span
                                className={`h-2 w-2 shrink-0 rounded-full ${
                                    current ? 'bg-mustard-300' : past ? 'bg-pine-400' : 'bg-pine-600'
                                }`}
                            />
                            <span className="truncate font-medium">{step.label}</span>
                        </div>
                    </React.Fragment>
                );
            })}
        </div>
    );
}

/**
 * Визуализация этапов заказа (тёмная карточка, mustard / pine).
 */
const OrderStatusTimeline = ({status}) => {
    const norm = normalizeOrderStatusCode(status);
    const isCanceled = norm === 'CANCELED';
    const curIdx = orderFlowIndex(status);

    const shellClass =
        'rounded-2xl border-2 border-pine-700 bg-pine-900 p-4 text-cream-50 shadow-lg sm:p-5';

    if (isCanceled) {
        return (
            <div className={`relative ${shellClass}`}>
                <StepsRow curIdx={0} ghost />
                <p className="absolute inset-0 flex items-center justify-center px-4 text-center text-sm font-medium text-red-200/95">
                    Заказ отменён
                </p>
            </div>
        );
    }

    return (
        <div role="region" aria-label="Прогресс заказа" className={shellClass}>
            <StepsRow curIdx={curIdx} />
        </div>
    );
};

export default OrderStatusTimeline;
